<template>
  <div>
    <div class="nav-container-landing">
      <nav class="navbar navbar-main navbar-expand-md navbar-1">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            Already have an account?
            <span class="nav-link" id="nav-login" @click="goToLogin()">Login here.</span>
          </li>
        </ul>
      </nav>

      <nav class="navbar navbar-main navbar-expand-md navbar-2">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <router-link class="nav-link" to="/request-demo">Request Invite</router-link>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#reasons">What we do?</a>
          </li>
        </ul>
      </nav>
    </div>

    <div class="jumbotron landing-page">
      <h1 class="display-4">YeyPass</h1>
      <p class="lead">Your secured identity pass in the real world.</p>

      <div class="row">
        <div class="col-md-2 id-card"></div>
        <div class="col-md-10 get-started">
          <p>Be part of Yeypass.<br>Sign up as an early adopter.</p>
          <router-link class="btn btn-primary btn-lg btn-shadow" to="/request-demo" role="button">
            Request Invite
          </router-link>
        </div>
      </div>

      <div id="smart-city"></div>

      <!--white trapezoid overlay-->
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none">
        <polygon fill="white" points="0,100 100,0 100,100"/>
      </svg>
    </div>

    <div id="reasons">
    </div>
    <div class="reasons-head">
      <!-- YeyPass for Everyone-->
      <h1>YeyPass for <span>Everyone</span></h1>
      <hr>
    </div>

    <div class="reasons">
      <!-- For Individuals -->
      <h1>For You</h1>
      <p>Protect your identity. Share only what is needed.</p>

      <div class="container subreasons">
        <div class="row">
          <div class="col-sm">
            <h3>Privacy</h3>
            <p>All personal information are private. Only necessary visiting details are shared for verification.</p>
          </div>
          <div class="col-sm">
            <h3>Safety</h3>
            <p>Protect your identity. Know how companies are using & storing your personal information. </p>
          </div>
          <div class="col-sm">
            <h3>Convenience</h3>
            <p>Go in hassle free. No more writing on papers, logbooks, and forms. All you need is our app!</p>
          </div>
        </div>
      </div>

      <div class="call-to-action">
        <router-link class="btn btn-primary btn-lg" to="/request-demo" role="button">
          Request Invite
        </router-link>
      </div>
    </div>

    <div class="reasons">
      <!-- For Businesses -->
      <h1>For Business</h1>
      <p>Secured and efficient visitor identity checkin platform for your office or establishment.</p>

      <div class="container subreasons">
        <div class="row">
          <div class="col-sm">
            <h3>Security</h3>
            <p>Manage and monitor visitors coming in and out of your office or building.</p>
          </div>
          <div class="col-sm">
            <h3>Authenticity</h3>
            <p>Visitors with YeyPass account can be verified to keep your office or building safe from impostors.</p>
          </div>
          <div class="col-sm">
            <h3>Efficiency</h3>
            <p>Access relevant digital logs and records that are easy to view and analyze.</p>
          </div>
        </div>
      </div>

      <div class="call-to-action">
        <router-link class="btn btn-primary btn-lg" to="/request-demo" role="button">Request for a demo</router-link>
      </div>
    </div>

    <mailing-list header_text="Be the first to know" sub_text="Receive the latest news and updates from the Yeypass team." base_name="Mailing%20List%20Top"/>

    <footer-view />
  </div>
</template>

<script>

import MailingList from '@/components/MailingList'
import Footer from '@/components/common/Footer'

import '@/assets/styles/landing-page.css'

export default {
  components: {
    // 'user-type-form': UserTypeform,
    'mailing-list': MailingList,
    'footer-view': Footer
  },
  data() {
    return { }
  },
  methods: {
    goToLogin() {    // TODO: change this to be modal next time
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.col-sm {
	margin: 15px;
	padding-right: 30px;
	padding-left: 30px;
	text-align: center;
	border-radius: 10px;
	background-color: #F2F3F4;
	color: #00386A;
	font-weight: lighter;
}

@media only screen and (max-width: 480px) {
  .jumbotron.landing-page {
    padding-left: 25px;
  }

  .nav-container-landing {
    padding-right: 10px;
  }

  .navbar-1 {
    padding-top: 0px;
  }

  .navbar-nav{
    min-height: 25px;
  }

  .nav-item a {
    font-size: 15px;
  }
}

</style>



// WEBPACK FOOTER //
// src/containers/LandingPage.vue